// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { savesConfig } from '@/lib/analytics/kpis/pinterest/saves';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerSavesConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...savesConfig,
    id: 'saves',
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
